import React, { Component } from 'react';

import './Searchbar.scss';

class Searchbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      focus: false
    };

    this.handleSubmit = this.handleChange.bind(this);
    this.handleChange = this.handleSubmit.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.handleFocus = this.handleFocus.bind(this);

  }

  componentWillMount(){
    if(this.props.page.naam === 'zoeken') this.setState({focus: true})
  }

  componentWillUpdate(){
    if(this.props.page.naam === 'zoeken' && this.state.focus === false) this.setState({focus: true})
  }

  handleChange(event) {
    const searchstring = event.target.value;
    this.props.search(searchstring);

    if (searchstring.length > 2 && this.props.page.naam !== 'zoeken') {
      this.props.history.push('/zoeken')
    }
  }

  handleSubmit(event) {
    event.preventDefault();
  }

  onKeyPress(event) {
    if (event.which === 13 /* Enter */) {
      event.preventDefault();
      this.props.history.push('/zoeken')
    }
  }

  handleFocus(event) {
    event.target.value = '';
    event.target.value = this.props.searchstring;
  }

  render() {
    return (
      <form className='page-search-bar' onSubmit={this.handleSubmit} onKeyPress={this.onKeyPress}>
        <input
          aria-label='searchbar'
          type='text'
          autoFocus={this.state.focus}
          onFocus={this.handleFocus}
          value={this.props.searchstring}
          onChange={this.handleChange}
          placeholder='Zoek in de app...' />
      </form>
    );
  }
}

export default Searchbar;

